import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import ShortAnswerQuestionComponent from "./short-answer-question-component.vue";
import { ShortAnswerQuestionAnswerProtobufSerializer } from "./short-answer-question-answer-protobuf-serializer";

export const shortAnswerQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(ShortAnswerQuestionComponent)
    .whenTargetNamed("short-answer");
    
    bind(SerializationApi.StateSerializationPluginSymbol).to(ShortAnswerQuestionAnswerProtobufSerializer)
});
